import { $Call } from 'utility-types';
import React, { Children } from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { noop, isEmpty } from 'lodash';
import { useTracking } from 'Tracking/tracking-api/useTracking';
import { themes } from './NavTag.themes';
export type Props = {
  children: React.ReactNode;
  className?: string;
  colorActive?: Colors;
  colorUnactive?: Colors;
  href?: string;
  isActive?: boolean;
  onClick?: (arg0: React.SyntheticEvent) => void;
  theme?: keyof $Call<typeof themes>;
  trackingData?: TrackingData | null | undefined;
};
export const NavTag = ({
  children,
  className,
  colorActive,
  colorUnactive,
  href,
  isActive,
  onClick,
  theme = 'default',
  trackingData = {},
  ...rest
}: Props) => {
  const tracker = useTracking();
  const track = !isEmpty(trackingData) && onClick ? () => tracker(trackingData) : noop;

  if (!Children.count(children)) {
    return null;
  }

  let TagName = 'div';

  if (href) {
    TagName = 'a';
  } else if (onClick) {
    TagName = 'button';
  }

  const { thRoot } = themes({
    colorActive,
    colorUnactive,
    isActive,
  })[theme];
  return (
    <TagName
      data-testid="Tag"
      {...rest}
      className={classnames(thRoot, className)}
      onClick={(e) => {
        onClick?.(e);
        track();
      }}
      href={href}
      {...(onClick
        ? {
            type: href ? 'link' : 'button',
          }
        : null)}
    >
      {children}
    </TagName>
  );
};
